/* WPC 2026 v13: lange teksten (3+ tussenkoppen, 2500+ tekens) krijgen op brede schermen een inhoudsopgave en een hulpkaart in de lege ruimte rechts. Onder 1200px verandert er niets. */
(function(){
  var d=document,w=window;
  function slug(t){return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60)||'kop'}
  function el(tag,cls,html){var e=d.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e}
  function freeSpace(b){
    var bw=b.getBoundingClientRect().width,mx=0;
    [].forEach.call(b.querySelectorAll('p,ul,ol'),function(e){mx=Math.max(mx,e.getBoundingClientRect().width)});
    return bw-mx;
  }
  function build(b){
    var hs=[].filter.call(b.querySelectorAll('h2,h3'),function(h){return h.textContent.trim().length>3&&!h.closest('table')});
    if(hs.length<3||b.textContent.replace(/\s+/g,' ').length<2500)return;
    var col=b.closest('.template-article .col-md-8'),row=col&&col.parentElement,asCol=false;
    if(col&&row&&row.getBoundingClientRect().width-col.getBoundingClientRect().width>=300)asCol=true;
    else if(freeSpace(b)<280)return;
    var used={},list=el('ol');
    hs.forEach(function(h){
      var id=h.id||('wpc-'+slug(h.textContent));while(used[id]||(d.getElementById(id)&&d.getElementById(id)!==h))id+='-2';used[id]=1;h.id=id;
      var li=el('li'),a=el('a');a.href='#'+id;a.textContent=h.textContent.trim().replace(/\s+/g,' ');li.appendChild(a);list.appendChild(li);
    });
    var wrap=el('div','wpc-lr'),body=el('div','wpc-lr__body'),aside=el('aside','wpc-lr__aside');
    aside.setAttribute('aria-label','Op deze pagina');
    if(!asCol)while(b.firstChild)body.appendChild(b.firstChild);
    var nav=el('nav','wpc-toc');nav.setAttribute('aria-label','Inhoud van deze tekst');nav.appendChild(el('p','wpc-toc__t','Op deze pagina'));nav.appendChild(list);aside.appendChild(nav);
    if(!/\/collections\/samples/.test(location.pathname)){
      aside.appendChild(el('div','wpc-help','<p class="wpc-help__t">Twijfel je over kleur of structuur?</p><p>Bestel samples voor €1. Het bedrag verrekenen we bij je bestelling.</p><a class="wpc-help__btn" href="/collections/samples">Bestel samples</a><p class="wpc-help__s">Of bel <a href="tel:+31854017189">+31&nbsp;(0)85&nbsp;401&nbsp;71&nbsp;89</a></p>'));
    }
    if(asCol){var c=el('div','col-md-4 wpc-lr-col');c.appendChild(aside);row.appendChild(c);b.classList.add('wpc-lr-art')}
    else{wrap.appendChild(body);wrap.appendChild(aside);b.appendChild(wrap)}
    /* sticky werkt niet onder overflow:hidden; clip knipt hetzelfde af zonder scrollcontext */
    for(var a=aside.parentElement;a&&a!==d.body;a=a.parentElement){var cs=getComputedStyle(a);if(/hidden|auto|scroll/.test(cs.overflowX+cs.overflowY)){a.style.overflow='clip'}}
    var links=list.querySelectorAll('a'),cur=-1,tick=false;
    function mark(){tick=false;var lim=w.innerHeight*.35,k=0;for(var x=0;x<hs.length;x++){if(hs[x].getBoundingClientRect().top<=lim)k=x;else break}
      if(k===cur)return;if(cur>-1){links[cur].classList.remove('is-on');links[cur].removeAttribute('aria-current')}cur=k;links[k].classList.add('is-on');links[k].setAttribute('aria-current','true');
      var ol=list,li=links[k].parentElement;if(li.offsetTop<ol.scrollTop||li.offsetTop+li.offsetHeight>ol.scrollTop+ol.clientHeight)ol.scrollTop=li.offsetTop-ol.clientHeight/3}
    w.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(mark)}},{passive:true});mark();
  }
  function run(){
    if(w.innerWidth<1200)return;
    [].forEach.call(d.querySelectorAll('.page-container .grid__item-inner--html, .template-article .rte'),function(b){
      if(b.getAttribute('data-wpc-lr'))return;b.setAttribute('data-wpc-lr','1');
      try{build(b)}catch(e){}
    });
  }
  if(d.readyState==='complete')run();else w.addEventListener('load',run);
})();
/* WPC 2026 v14: lange collectiebeschrijving in de hero (meer dan ~600 tekens) inklappen tot een paar regels met een knop "Lees verder". Alle tekst blijft in de HTML (SEO); zonder JS staat alles open. */
(function(){
  var d=document;
  function run(){
    [].forEach.call(d.querySelectorAll('.collection-hero .collection-hero__description'),function(b,i){
      if(b.getAttribute('data-wpc-more'))return;b.setAttribute('data-wpc-more','1');
      [].forEach.call(b.querySelectorAll('p'),function(p){if(!p.textContent.replace(/[\s\u00a0\u200b\u2060]+/g,'')&&!p.querySelector('img,picture,iframe,video,svg,a,input'))p.style.display='none'});
      if(b.textContent.replace(/\s+/g,' ').trim().length<600)return;
      if(!b.id)b.id='wpc-desc-'+i;
      b.classList.add('wpc-clamp');
      if(b.scrollHeight<=b.clientHeight+24){b.classList.remove('wpc-clamp');return}
      var btn=d.createElement('button');btn.type='button';btn.className='wpc-more';btn.setAttribute('aria-expanded','false');btn.setAttribute('aria-controls',b.id);btn.textContent='Lees verder';
      btn.addEventListener('click',function(){var open=b.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');btn.textContent=open?'Minder tekst':'Lees verder';if(!open)b.scrollIntoView({block:'nearest'})});
      b.parentNode.insertBefore(btn,b.nextSibling);
    });
  }
  if(d.readyState!=='loading')run();else d.addEventListener('DOMContentLoaded',run);
})();
/* vNN firefox: Firefox breekt regels na een schuine streep tussen letters ("t/ m", "Afwerklijst/ Onderbalk", "palen/ hardhouten"). WebKit en Chromium niet. Zet een word-joiner (U+2060) na de streep; alleen in korte woord/woord-combinaties, niet in URL's. */
(function(){
  var d=document,WJ='⁠',re=/(^|[\s(“"'])([A-Za-zÀ-ÿ]{1,24})\/([A-Za-zÀ-ÿ]{1,24})(?=$|[\s.,;:!?)”"'])/g;
  var SKIP='script,style,noscript,textarea,input,select,option,code,pre,svg,[contenteditable]';
  function run(){
    if(!d.body)return;
    var tw=d.createTreeWalker(d.body,NodeFilter.SHOW_TEXT,{acceptNode:function(n){if(n.nodeValue.indexOf('/')<0)return 2;var p=n.parentElement;return(!p||p.closest(SKIP))?2:1}}),n,ts=[];
    while(n=tw.nextNode())ts.push(n);
    ts.forEach(function(t){var s=t.nodeValue,o=s.replace(re,function(m,a,b,c){return a+b+'/'+WJ+c});if(o!==s)t.nodeValue=o});
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('load',function(){run();setTimeout(run,2500)});
})();
/* WPC 2026 v14l: zichtbare melding na toevoegen aan winkelwagen (theme.js toont niets als het winkelwagenpaneel uit staat) + vangnet voor theme.crosssell (TypeError in AjaxCart.success) */
(function(){
  var d=document,w=window,t,el;
  function guard(){try{if(w.theme&&!w.theme.crosssell)w.theme.crosssell={showPopup:function(){}}}catch(e){}}
  guard();d.addEventListener('DOMContentLoaded',guard);w.addEventListener('load',guard);
  w.wpcToast=function(ok,title){
    if(!el){el=d.createElement('div');el.className='wpc-toast';el.setAttribute('aria-hidden','true');d.body.appendChild(el)}
    el.className='wpc-toast'+(ok?'':' wpc-toast--err');
    el.innerHTML=ok?'<span class="wpc-toast__t"></span><a class="wpc-toast__a" href="/cart" tabindex="-1">Bekijk winkelwagen</a>':'<span class="wpc-toast__t">Toevoegen is niet gelukt. Probeer het opnieuw of bel ons.</span>';
    if(ok)el.querySelector('.wpc-toast__t').textContent=(title?title+' ':'')+(title?'is toegevoegd':'Toegevoegd aan je winkelwagen');
    try{var hd=d.querySelector('.section-header .site-header')||d.querySelector('.section-header');var hb=hd?hd.getBoundingClientRect().bottom:0;el.style.top=Math.max(12,Math.min(hb,220))+12+'px'}catch(e){}
    requestAnimationFrame(function(){el.classList.add('is-on')});
    clearTimeout(t);t=setTimeout(function(){el.classList.remove('is-on')},5000);
  };
})();
/* WPC 2026 a11y-voorstel (fix.js): toetsenbord, focus en schermlezer-semantiek voor header, panelen en productformulier.
   Zelfstandige IIFE, vanilla, geen dependencies. Idempotent: mag meerdere keren draaien.
   Plaatsing: achteraan assets/wpc-2026-v13.js (of als apart bestand met defer na theme.js). */
(function () {
  'use strict';
  if (window.__wpcA11y) return; window.__wpcA11y = true;
  var d = document, w = window;
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"]),summary,[contenteditable="true"]';
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function shown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 1 || r.height < 1) return false;
    for (var x = el; x && x.nodeType === 1; x = x.parentElement) {
      var c = getComputedStyle(x);
      if (c.visibility === 'hidden' || c.display === 'none' || +c.opacity === 0) return false;
    }
    return true;
  }
  function focusables(root) { return $$(FOCUSABLE, root).filter(function (el) { return el.tabIndex >= 0 && shown(el); }); }
  function setInert(el, on) {
    if (!el) return;
    if (on) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
    else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
  }
  function asButton(el, label) {
    if (!el || el.getAttribute('data-wpc-btn')) return;
    el.setAttribute('data-wpc-btn', '1');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.removeAttribute('aria-hidden');
    el.removeAttribute('focusable');
    if (label) el.setAttribute('aria-label', label);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); el.click(); }
    });
  }
  /* Focus vasthouden in een open paneel (Tab/Shift+Tab rondgaan). */
  function trap(container, e) {
    var f = focusables(container);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = d.activeElement;
    if (!container.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- 0. Live-regio voor meldingen ---------- */
  var live;
  function announce(msg) {
    if (!live) {
      live = d.createElement('div');
      live.className = 'wpc-sr-only'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true');
      d.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* ---------- 1. Skip-link en ankers: focus echt verplaatsen (theme.anchorScroll doet preventDefault en scrolt alleen) ---------- */
  var main = d.getElementById('MainContent');
  if (main && !main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!id) return;
    var t = d.getElementById(id);
    if (!t) return;
    if (!t.matches(FOCUSABLE)) { if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1'); }
    setTimeout(function () { t.focus({ preventScroll: true }); }, 0);
  });

  /* ---------- 2. Aankondigingsbalk: 9 van de 10 kopieën verbergen voor schermlezer en toetsenbord; pauzeknop (WCAG 2.2.2) ---------- */
  $$('.announcement-wrapper.announcement-scroll').forEach(function (wrap) {
    if (wrap.getAttribute('data-wpc-a11y')) return; wrap.setAttribute('data-wpc-a11y', '1');
    $$('.announcement-item', wrap).forEach(function (it, i) {
      if (i === 0) return;
      it.setAttribute('aria-hidden', 'true');
      $$('a,button', it).forEach(function (x) { x.setAttribute('tabindex', '-1'); });
    });
    var bar = wrap.parentElement;
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'wpc-ann-pause'; b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Bewegende tekst pauzeren');
    b.innerHTML = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12"><rect x="2" y="1" width="3" height="10" fill="currentColor"/><rect x="7" y="1" width="3" height="10" fill="currentColor"/></svg>';
    b.addEventListener('click', function () {
      var p = bar.classList.toggle('wpc-paused');
      b.setAttribute('aria-pressed', p ? 'true' : 'false');
      b.setAttribute('aria-label', p ? 'Bewegende tekst afspelen' : 'Bewegende tekst pauzeren');
      b.innerHTML = p ? '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12"><path d="M2 1l9 5-9 5z" fill="currentColor"/></svg>' : '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12"><rect x="2" y="1" width="3" height="10" fill="currentColor"/><rect x="7" y="1" width="3" height="10" fill="currentColor"/></svg>';
    });
    bar.appendChild(b);
  });

  /* ---------- 3. Account-link zonder naam ---------- */
  $$('a.site-account').forEach(function (a) {
    if (!a.getAttribute('aria-label') && !(a.innerText || '').trim()) a.setAttribute('aria-label', 'Inloggen of account');
  });

  /* ---------- 4. Desktopmenu: openklapknop per dropdown (zichtbaar bij toetsenbordfocus), Escape sluit ---------- */
  $$('.site-header .site-nav > .site-nav__item').forEach(function (li, i) {
    var link = $(':scope > a.dropdown-toggle', li), dd = $(':scope > .site-nav__dropdown', li);
    if (!link || !dd || li.getAttribute('data-wpc-dd')) return;
    li.setAttribute('data-wpc-dd', '1');
    if (!dd.id) dd.id = 'wpc-dd-' + i;
    var name = (link.innerText || '').trim().replace(/\s+/g, ' ');
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'wpc-dd-toggle';
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', dd.id);
    b.innerHTML = '<span class="wpc-sr-only"></span><svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    b.firstChild.textContent = 'Submenu ' + name;
    link.insertAdjacentElement('afterend', b);
    function set(open) {
      li.classList.toggle('wpc-dd-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    b.addEventListener('click', function () { set(!li.classList.contains('wpc-dd-open')); }); /* disclosure-patroon: focus blijft op de knop, Tab gaat het submenu in */
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && li.classList.contains('wpc-dd-open')) { e.preventDefault(); set(false); b.focus(); }
    });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) set(false); });
    li.addEventListener('mouseenter', function () { b.setAttribute('aria-expanded', 'true'); });
    li.addEventListener('mouseleave', function () { if (li.classList.contains('wpc-dd-open') && !li.contains(d.activeElement)) set(false); else if (!li.classList.contains('wpc-dd-open')) b.setAttribute('aria-expanded', 'false'); });
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* hover-dropdown wegklikken met Escape (1.4.13): tijdelijk verbergen tot de muis het item verlaat */
    var h = $$('.site-header .site-nav > .site-nav__item:hover');
    h.forEach(function (li) { li.classList.add('wpc-dd-dismissed'); var t = $(':scope > .wpc-dd-toggle', li); if (t) t.setAttribute('aria-expanded', 'false'); li.addEventListener('mouseleave', function f() { li.classList.remove('wpc-dd-dismissed'); li.removeEventListener('mouseleave', f); }); });
  });

  /* ---------- 5. Zoekpaneel ---------- */
  (function () {
    var modal = $('.detail-modal'), panel = $('.search-modal'), content = $('.search-modal__content');
    if (!modal || !panel) return;
    var outer = $('.header__icon--search[role=button]');
    if (outer) { outer.removeAttribute('role'); outer.removeAttribute('aria-label'); outer.removeAttribute('aria-expanded'); outer.removeAttribute('aria-haspopup'); }
    var toggles = $$('.modal__toggle-open, .modal__toggle-search-mobile');
    toggles.forEach(function (t) { asButton(t, 'Zoeken'); t.setAttribute('aria-expanded', 'false'); t.setAttribute('aria-haspopup', 'dialog'); });
    var closeBtn = $('.search-modal__close-button');
    if (closeBtn) closeBtn.setAttribute('aria-label', 'Zoeken sluiten');
    var opener = null, wasOpen = modal.classList.contains('active');
    toggles.forEach(function (t) { t.addEventListener('click', function () { opener = t; }, true); });
    setInert(panel, !wasOpen);
    function sync() {
      var open = modal.classList.contains('active');
      if (open === wasOpen) return; wasOpen = open;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      setInert(panel, !open);
      if (open) {
        setTimeout(function () { var i = d.getElementById('Search-In-Modal'); if (i && !panel.contains(d.activeElement)) i.focus(); }, 80);
      } else {
        var back = opener && shown(opener) ? opener : toggles.filter(shown)[0];
        if (back && (panel.contains(d.activeElement) || d.activeElement === d.body)) back.focus();
      }
    }
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['class'] });
    d.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('active')) return;
      if (e.key === 'Escape') { e.preventDefault(); if (closeBtn) closeBtn.click(); }
      else if (e.key === 'Tab') trap(content || panel, e);
    });
  })();

  /* ---------- 6. Winkelwagenpaneel ---------- */
  (function () {
    var wrap = $('.site-header .js-mini-cart') || $('.js-mini-cart'), tog = wrap && $('.js-toggle-cart', wrap), panel = wrap && $('.mini-cart-content', wrap);
    if (!wrap || !tog || !panel) return;
    if (!panel.id) panel.id = 'wpc-mini-cart';
    panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Winkelwagen');
    function label() {
      var c = $('.js-cart-count', tog), n = c ? parseInt(c.textContent, 10) || 0 : 0;
      tog.setAttribute('aria-label', 'Winkelwagen, ' + n + (n === 1 ? ' artikel' : ' artikelen'));
    }
    asButton(tog); label();
    tog.setAttribute('aria-controls', panel.id); tog.setAttribute('aria-expanded', 'false');
    var x = $('.close', panel); if (x) x.setAttribute('aria-label', 'Winkelwagen sluiten');
    var byUser = false, isOpen = wrap.classList.contains('active'), offCanvas = wrap.classList.contains('cardraw');
    tog.addEventListener('click', function () { byUser = true; }, true);
    if (offCanvas) setInert(panel, !isOpen); /* hover-dropdown (cartdraw uit): het thema verbergt hem zelf met visibility; inert zou de knoppen onklikbaar maken */
    function sync() {
      label();
      var open = wrap.classList.contains('active');
      if (open === isOpen) return; isOpen = open;
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (offCanvas) setInert(panel, !open);
      if (open && byUser) setTimeout(function () { var f = focusables(panel)[0]; if (f) f.focus(); }, 80);
      if (!open && (panel.contains(d.activeElement) || d.activeElement === d.body) && byUser) tog.focus();
      if (!open) byUser = false;
    }
    new MutationObserver(sync).observe(wrap, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true, characterData: true });
    d.addEventListener('keydown', function (e) {
      if (!wrap.classList.contains('active')) return;
      if (e.key === 'Escape') { e.preventDefault(); byUser = true; wrap.classList.remove('active'); }
      else if (e.key === 'Tab' && panel.contains(d.activeElement)) trap(panel, e);
    });
    /* door theme.js gegenereerde regels: Nederlandse labels, alt-tekst, aantal-veld met label */
    /* idempotent: alleen schrijven als de waarde echt anders is; observer staat tijdens het bijwerken uit
       (eerder zette textContent elke keer opnieuw een tekstknoop -> childList-mutatie -> oneindige lus = bevroren pagina na toevoegen) */
    function sa(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
    var mo = null, busy = false, c = $('.js-mini-cart-content', panel);
    function fixItems() {
      if (busy) return; busy = true;
      if (mo) mo.disconnect();
      try {
        $$('.js-qty__minus', panel).forEach(function (b) { sa(b, 'aria-label', 'Aantal met één verlagen'); });
        $$('.js-qty__plus', panel).forEach(function (b) { sa(b, 'aria-label', 'Aantal met één verhogen'); });
        $$('.js-remove-mini-cart', panel).forEach(function (b) {
          var t = b.closest('.mini-cart-item'), n = t && $('.mini-cart-meta a', t);
          if (b.textContent.trim() !== 'Verwijderen') b.textContent = 'Verwijderen';
          if (n) sa(b, 'aria-label', 'Verwijder ' + n.textContent.trim());
        });
        $$('.change-minicart', panel).forEach(function (i) {
          var t = i.closest('.mini-cart-item'), n = t && $('.mini-cart-meta a', t);
          sa(i, 'aria-label', 'Aantal' + (n ? ' ' + n.textContent.trim() : '')); sa(i, 'inputmode', 'numeric');
        });
        $$('.mini-cart-image', panel).forEach(function (a) {
          var t = a.closest('.mini-cart-item'), n = t && $('.mini-cart-meta a', t), img = $('img', a);
          if (img && !img.hasAttribute('alt')) img.setAttribute('alt', '');
          if (n) { sa(a, 'tabindex', '-1'); sa(a, 'aria-hidden', 'true'); } /* dubbele link naar hetzelfde product */
        });
      } finally {
        busy = false;
        if (mo && c) mo.observe(c, { childList: true, subtree: true });
      }
    }
    if (c) { mo = new MutationObserver(fixItems); fixItems(); }
  })();

  /* ---------- 7. Mobiel menu (drawer) ---------- */
  (function () {
    var drawer = d.getElementById('NavDrawer'), btns = $$('.js-drawer-open-left');
    if (!drawer || !btns.length) return;
    drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('aria-label', 'Menu');
    btns.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', 'NavDrawer');
      var v = $('.visually-hidden', b); if (v && /navigation/i.test(v.textContent)) v.textContent = 'Menu';
    });
    var x = $('.js-drawer-close .close', drawer); if (x && !x.getAttribute('aria-label')) x.setAttribute('aria-label', 'Menu sluiten');
    $$('.drawer__nav-toggle-btn', drawer).forEach(function (t) {
      var tgt = d.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-expanded', tgt && tgt.classList.contains('show') ? 'true' : 'false');
      var nm = t.getAttribute('aria-label'); if (nm && !/^submenu/i.test(nm)) t.setAttribute('aria-label', 'Submenu ' + nm);
      if (tgt) tgt.removeAttribute('role'); /* role=navigation op elk submenu is overbodig */
    });
    var opener = null, root = d.documentElement, isOpen = false;
    btns.forEach(function (b) { b.addEventListener('click', function () { opener = b; }, true); });
    setInert(drawer, true);
    function sync() {
      var open = root.classList.contains('js-drawer-open-left') || d.body.classList.contains('js-drawer-open-left');
      if (open === isOpen) return; isOpen = open;
      setInert(drawer, !open);
      btns.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) setTimeout(function () { var f = focusables(drawer); if (f.length && !drawer.contains(d.activeElement)) f[0].focus(); }, 120);
      else { var back = opener && shown(opener) ? opener : btns.filter(shown)[0]; if (back) setTimeout(function () { back.focus(); }, 50); }
    }
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(sync).observe(d.body, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------- 8. Toegevoegd aan winkelwagen: aankondigen (aria-live) ---------- */
  (function () {
    function done(ok, body) {
      var title = '';
      try { var j = JSON.parse(body); title = j.product_title || (j.items && j.items[0] && j.items[0].product_title) || ''; } catch (e) {}
      if (!ok) { announce('Toevoegen aan je winkelwagen is niet gelukt.'); if (w.wpcToast) w.wpcToast(false, ''); return; }
      if (w.wpcToast) w.wpcToast(true, title);
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          announce((title ? title + ' is t' : 'T') + 'oegevoegd aan je winkelwagen. Je winkelwagen bevat nu ' + c.item_count + (c.item_count === 1 ? ' artikel.' : ' artikelen.'));
        }).catch(function () { announce('Toegevoegd aan je winkelwagen.'); });
      }, 150);
    }
    var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); };
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__wpcAdd = isAdd(u); return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__wpcAdd) { var x = this; x.addEventListener('loadend', function () { done(x.status >= 200 && x.status < 300, x.responseText); }); }
      return XS.apply(this, arguments);
    };
    if (w.fetch) {
      var F = w.fetch;
      w.fetch = function (input) {
        var u = typeof input === 'string' ? input : input && input.url, p = F.apply(this, arguments);
        if (isAdd(u)) p.then(function (r) { r.clone().text().then(function (t) { done(r.ok, t); }); }).catch(function () { done(false, ''); });
        return p;
      };
    }
  })();

  /* ---------- 9. Kleine labels: prijsfilter-schuifjes, slick-pijlen, ophaaldrawer ---------- */
  function labels() {
    $$('.noUi-handle-lower').forEach(function (h) { if (!h.getAttribute('aria-label')) h.setAttribute('aria-label', 'Minimumprijs'); });
    $$('.noUi-handle-upper').forEach(function (h) { if (!h.getAttribute('aria-label')) h.setAttribute('aria-label', 'Maximumprijs'); });
    $$('button.slick-prev').forEach(function (b) { b.setAttribute('aria-label', 'Vorige afbeelding'); });
    $$('button.slick-next').forEach(function (b) { b.setAttribute('aria-label', 'Volgende afbeelding'); });
    $$('.pickup-availability-drawer-button[aria-label="close"]').forEach(function (b) { b.setAttribute('aria-label', 'Sluiten'); });
    /* aantal-velden die theme.js (QtySelector) opnieuw opbouwt verliezen hun aria-label; aria-live op een invoerveld weg */
    $$('input.js-qty__input').forEach(function (i) {
      i.removeAttribute('aria-live');
      if (!i.getAttribute('aria-label')) {
        var row = i.closest('.cart__row, tr, .mini-cart-item, .product-form'), n = row && $('.cart__product-name, .list-view-item__title a, .mini-cart-meta a, h1', row);
        i.setAttribute('aria-label', 'Aantal' + (n ? ' ' + n.textContent.trim().replace(/\s+/g, ' ') : ''));
      }
    });
    /* offerteformulier (PifyApp-iframe) en Trustpilot: herkenbare iframe-titel */
    $$('iframe[id^="form-iframe-"]').forEach(function (f) { if (/^Ingesloten inhoud$|^$/.test(f.title || '')) f.title = 'Offerteformulier'; });
  }
  labels();
  w.addEventListener('load', labels);

  /* ---------- 10. Vaste productbalk (#js-sticky-prd) alleen focusbaar als hij in beeld is ---------- */
  (function () {
    var bar = d.getElementById('js-sticky-prd'); bar = bar && (bar.closest('.sticky-cart-wr') || bar);
    if (!bar) return;
    var last = null;
    function s() { var vis = bar.classList.contains('active') && !bar.classList.contains('disable'); if (vis !== last) { last = vis; setInert(bar, !vis); } d.documentElement.style.setProperty('--wpc-sticky-h', vis ? bar.offsetHeight + 'px' : '0px'); }
    s(); new MutationObserver(s).observe(bar, { attributes: true, attributeFilter: ['class'] }); w.addEventListener('resize', s);
  })();
})();

/* WPC 2026 v14r: winkelwagenpagina: elke regel heeft een mobiel en een desktop aantal-veld in hetzelfde formulier. Bij versturen (Afrekenen/Bijwerken)
   alleen het zichtbare veld meesturen, zodat Shopify per regel precies één (het juiste) aantal krijgt. */
(function(){
  var d=document;
  d.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.matches||!f.matches('form[action$="/cart"],form[action="/cart"]'))return;
    var q=f.querySelectorAll('input[name^="updates["]');
    [].forEach.call(q,function(i){if(i.offsetParent===null&&!i.disabled){i.disabled=true;i.setAttribute('data-wpc-off','1')}});
    setTimeout(function(){[].forEach.call(f.querySelectorAll('[data-wpc-off]'),function(i){i.disabled=false;i.removeAttribute('data-wpc-off')})},1500);
  },true);
})();
/* WPC 2026 v15: uitklapblokken op productpagina's (custom-liquid .accordion[onclick], Molding .tabcustom, .accordion-header) bedienbaar met toetsenbord:
   role=button, tabindex=0, aria-expanded volgt de open/dicht-klasse, Enter/spatie = klik. Alleen de kop wordt knop; de inhoud is een sibling. */
(function(){
  var d=document;
  function init(){
    [].forEach.call(d.querySelectorAll('div.accordion[onclick], div.tabcustom[data-toggle="collapse"], .accordion-header'),function(h){
      if(h.getAttribute('data-wpc-acc'))return; h.setAttribute('data-wpc-acc','1');
      if(!h.hasAttribute('role'))h.setAttribute('role','button');
      if(!h.hasAttribute('tabindex'))h.tabIndex=0;
      function st(){var open=h.classList.contains('open')||(h.hasAttribute('data-toggle')&&!h.classList.contains('collapsed'));var v=open?'true':'false';if(h.getAttribute('aria-expanded')!==v)h.setAttribute('aria-expanded',v)}
      st();
      h.addEventListener('click',function(){setTimeout(st,0);setTimeout(st,450)});
      h.addEventListener('keydown',function(e){if(e.target!==h)return;if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){e.preventDefault();h.click()}});
    });
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  window.addEventListener('load',init);
})();
/* WPC 2026 v15: blog-onderwerpen inklappen tot 2 regels als het er veel zijn; open als er een tag geselecteerd is */
(function(){
  var d=document;
  function run(){
    var box=d.querySelector('.template-blog__tags'); if(!box||box.getAttribute('data-wpc-tags'))return; box.setAttribute('data-wpc-tags','1');
    var items=box.querySelectorAll('li'); if(items.length<=14)return;
    var act=box.querySelector('li.active'); var first=items[0];
    if(act&&act!==first)return;
    box.classList.add('wpc-tags-clamp'); if(!box.id)box.id='wpc-blog-tags';
    var b=d.createElement('button'); b.type='button'; b.className='wpc-tags-more'; b.setAttribute('aria-expanded','false'); b.setAttribute('aria-controls',box.id);
    b.textContent='Alle onderwerpen ('+(items.length-1)+')';
    b.addEventListener('click',function(){var open=box.classList.toggle('wpc-tags-clamp')===false;b.setAttribute('aria-expanded',open?'true':'false');b.textContent=open?'Minder onderwerpen':'Alle onderwerpen ('+(items.length-1)+')'});
    box.parentNode.insertBefore(b,box.nextSibling);
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
})();
